import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import Alert from "react-bootstrap/Alert";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../../HelmetWrapper";
import Notifications from "../../push-notifications/Notifications";
// import MealsStructure from "../../diet/meal/MealsStructure";
// import BackAddBtns from "../../Open-pages/target-matrics/common/BackAddBtns";
import PTProspectForm from "./PTProspectForm";
import PTProspectListings from "./PTProspectListings";
import {
  fetchPtProspectsData,
  fetchPtProspectsStatsData,
} from "../../../redux/prospect-reducers/prospectSlice";
import CmnFilters from "../../lead-management/common/CmnFilters";
import "../../../styles/pt/pt-prospects.css";
import ClosureDateChange from "./ClosureDateChange";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import MembershipDetails from "../pt-flow-new/users-info/MembershipDetails";
import DetailModHeader from "../../common-components/DetailModHeader";
import CommonStructured from "../../common-components/CommonStructured";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const extractMemberCheckinTimes = (checkinArray) => {
  let last_checkin_start_end_time = [];

  checkinArray?.length > 0 &&
    checkinArray.forEach((item) => {
      const itemValue = item.value;
      last_checkin_start_end_time.push(itemValue);
    });

  return {
    last_checkin_start_end_time: last_checkin_start_end_time.join(", "),
  };
};

const extractTrainerCheckinTimes = (checkinArray) => {
  let last_checkin_start_end_time1 = [];

  checkinArray?.length > 0 &&
    checkinArray.forEach((item) => {
      const itemValue = item.value;
      last_checkin_start_end_time1.push(itemValue);
    });

  return {
    last_checkin_start_end_time1: last_checkin_start_end_time1.join(", "),
  };
};

const PTProspects = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { ptProspectsStatsLoading, ptProspectsLoading } = useSelector(
    (state) => state.prospects
  );

  const tableRef = useRef(null);
  const mobileTableRef = useRef(null);

  const isTrainer = userInfoData?.account_type === "trainer";
  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [activeCardIndex, setActiveCardIndex] = useState(null);

  const [selectedTab, setSelectedTab] = useState(0);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedTrainer: isTrainer
      ? {
          label: userInfoData?.name || "",
          value: userInfoData?.uid || userInfoData?.user_id || "",
        }
      : "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadConvertedDateFrom: "",
    leadConvertedDateTo: "",
    leadClosureDateFrom: "",
    leadClosureDateTo: "",
    lastCheckinDateFrom: "",
    lastCheckinDateTo: "",
    lastCheckinDate1From: "",
    lastCheckinDate1To: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    filter_type:
      activeCardIndex === "total" || !activeCardIndex ? "" : activeCardIndex,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",

    last_checkin_time_filter: "",
    trainer_last_checkin_time_filter: "",
    last_checkin_days_ago: allFilters.selectedCheckinDaysAgo?.value || "",
    trainer_last_checkin_days_ago:
      allFilters.selectedCheckinDaysAgo1?.value || "",

    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    converted_from: allFilters.leadConvertedDateFrom || "",
    converted_to: allFilters.leadConvertedDateTo || "",
    exp_closure_start_date: allFilters.leadClosureDateFrom || "",
    exp_closure_end_date: allFilters.leadClosureDateTo || "",
    last_checkin_from: allFilters.lastCheckinDateFrom || "",
    last_checkin_to: allFilters.lastCheckinDateTo || "",
    trainer_last_checkin_from: allFilters.lastCheckinDate1From || "",
    trainer_last_checkin_to: allFilters.lastCheckinDate1To || "",
    current_plan_status: selectedTab === 0 ? "active" : "expired",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
  };

  function handleOnClickBtn(formname, row) {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: formname,
      rowData: row,
    }));
  }

  function handleModalClose() {
    setModValues(iniModValues);
  }

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  function getPtProspectsStatsData(filters) {
    const { page, limit, filter_type, ...rest } = filters;

    dispatch(
      fetchPtProspectsStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getPtProspectsData(filters) {
    dispatch(
      fetchPtProspectsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  function getCombinedReload() {
    getPtProspectsData(filters);
    getPtProspectsStatsData(filters);
  }

  useEffect(() => {
    getPtProspectsStatsData(filters);
  }, [
    filters.gym_id,
    filters.trainer_id,
    filters.last_checkin_time_filter,
    filters.trainer_last_checkin_time_filter,
    filters.last_checkin_days_ago,
    filters.trainer_last_checkin_days_ago,
    filters.date_from,
    filters.date_to,
    filters.converted_from,
    filters.converted_to,
    filters.exp_closure_start_date,
    filters.exp_closure_end_date,
    filters.last_checkin_from,
    filters.last_checkin_to,
    filters.trainer_last_checkin_from,
    filters.trainer_last_checkin_to,
  ]);

  useEffect(() => {
    getPtProspectsData(filters);
  }, [filters]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
      selectedTrainer: isTrainer
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    const { last_checkin_start_end_time } = extractMemberCheckinTimes(
      allFilters.selectedCheckinTime
    );
    const { last_checkin_start_end_time1 } = extractTrainerCheckinTimes(
      allFilters.selectedCheckinTime1
    );

    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      filter_type:
        activeCardIndex === "total" || !activeCardIndex ? "" : activeCardIndex,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",

      last_checkin_time_filter: last_checkin_start_end_time || "",
      trainer_last_checkin_time_filter: last_checkin_start_end_time1 || "",
      last_checkin_days_ago: allFilters.selectedCheckinDaysAgo?.value || "",
      trainer_last_checkin_days_ago:
        allFilters.selectedCheckinDaysAgo1?.value || "",

      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      converted_from: allFilters.leadConvertedDateFrom || "",
      converted_to: allFilters.leadConvertedDateTo || "",
      exp_closure_start_date: allFilters.leadClosureDateFrom || "",
      exp_closure_end_date: allFilters.leadClosureDateTo || "",
      last_checkin_from: allFilters.lastCheckinDateFrom || "",
      last_checkin_to: allFilters.lastCheckinDateTo || "",
      trainer_last_checkin_from: allFilters.lastCheckinDate1From || "",
      trainer_last_checkin_to: allFilters.lastCheckinDate1To || "",
      current_plan_status: selectedTab === 0 ? "active" : "expired",
    }));
  }, [
    isPage,
    pageLimit,
    activeCardIndex,
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.selectedCheckinTime,
    allFilters.selectedCheckinTime1,
    allFilters.selectedCheckinDaysAgo,
    allFilters.selectedCheckinDaysAgo1,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.leadConvertedDateFrom,
    allFilters.leadConvertedDateTo,
    allFilters.leadClosureDateFrom,
    allFilters.leadClosureDateTo,
    allFilters.lastCheckinDateFrom,
    allFilters.lastCheckinDateTo,
    allFilters.lastCheckinDate1From,
    allFilters.lastCheckinDate1To,
    selectedTab,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: PT Prospect Management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {isCustom && (
          <div className="mt30">
            {userInfoData && !isIOS() && (
              <Notifications authData={userInfoData} />
            )}

            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </div>
        )}

        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={handleModalClose}
          contentLabel="Details Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "one_time_closure_date_update"
                ? "mod-width-50p"
                : ""
            }`}>
            {modValues.modName === "member_info" ? (
              <DetailModHeader
                info={modValues?.rowData}
                onClose={handleModalClose}
                isOnlySubscription={true}
              />
            ) : modValues.modName === "one_time_closure_date_update" ? (
              <ModalHeadAndClose
                title={`${modValues.modName?.replace(/_/g, " ")}`}
                onClose={handleModalClose}
              />
            ) : null}

            {modValues.modName === "one_time_closure_date_update" ? (
              <ClosureDateChange
                userInfoData={userInfoData}
                closeModal={handleModalClose}
                callFunction={() => getCombinedReload(filters)}
                rowData={modValues.rowData}
              />
            ) : modValues.modName === "member_info" ? (
              <>
                <MembershipDetails
                  userInfoData={userInfoData}
                  rowData={modValues?.rowData}
                  isOnlySubscription={true}
                />
                {/* <UserDetails
                  row={modValues?.rowData}
                  userInfoData={userInfoData}
                /> */}
              </>
            ) : (
              <PTProspectForm
                userInfoData={userInfoData}
                closeModal={handleModalClose}
                callFunction={() => getCombinedReload(filters)}
                // isEdit={modValues.modName === "one_time_closure_date_update"}
              />
            )}
          </div>
        </Modal>

        {/* <Row>
          <Col>
            <MealsStructure text={"PT Prospect Management"} />
          </Col>
        </Row> */}
        <Row>
          <Col>
            <CommonStructured
              pageHeading="PT Prospect Management"
              onClickBackBtn={isCustom ? handleBack : null}
              isReload={() => getCombinedReload()}
              createBtnTxt={isTrainer ? "Add New PT Prospect" : null}
              onClickCreateBtn={() => handleOnClickBtn("add")}
            />
            {/* <BackAddBtns
              isCustom={isCustom}
              onClickBack={isCustom ? handleBack : null}
              onClickReload={() => getCombinedReload()}
              isAddBtn={isTrainer ? true : false}
              addBtnTxt={"Add New PT Prospect"}
              onClickAdd={() => handleOnClickBtn("add")}
            /> */}
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"pt-prospects"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={ptProspectsStatsLoading || ptProspectsLoading}
              isProspect={true}
            />

            <PTProspectListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              activeCardIndex={activeCardIndex}
              setActiveCardIndex={setActiveCardIndex}
              tableRef={tableRef}
              mobileTableRef={mobileTableRef}
              handleOnClickBtn={handleOnClickBtn}
              selectedTab={selectedTab}
              handleTabSelect={handleTabSelect}
              setModValues={setModValues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default PTProspects;